import styles from "../FiltersToolbar.module.scss";
import dayjs from "dayjs";
import { useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { FilterValues } from '../../DynamicFilters.config';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { EDynamicColumnType, IDynamicColumnFilter, ISelectOption } from "Interfaces/Utils";
import { on } from "events";


interface IColumnGrid {
  filter: IDynamicColumnFilter;
  filterValues: FilterValues;
  handleChange: (field: string, value: any) => void;
  onOtherComponentChange?: (value: string) => void;
};


export const ColumnGrid = (props: IColumnGrid) => {

  const { filter, filterValues, handleChange,onOtherComponentChange } = props;

  const [element, setElement] = useState<JSX.Element>(<></>);

  useEffect(() => {
    if (filter.type === EDynamicColumnType.STRING) {
      setElement(
        <TextField
          fullWidth
          label={filter.label}
          className={styles.field}
          value={filterValues[filter.field]?.value || ""}
          onChange={(e) => handleChange(filter.field, e.target.value)}
          sx={{ marginBottom: "0px !important" }}
        />
      );
    }

    if (filter.type === EDynamicColumnType.NUMBER) {
      setElement(
        <TextField
          fullWidth
          label={filter.label}
          className={styles.field}
          type="text"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          value={filterValues[filter.field]?.value || ""}
          onChange={(e) => handleChange(filter.field, e.target.value)}
          sx={{ marginBottom: "0px !important" }}
        />
      );
    }

    if (filter.type === EDynamicColumnType.DATE) {
      setElement(
        <DesktopDatePicker
          label={filter.label}
          className={styles.field}
          slotProps={{
            textField: { fullWidth: true },
          }}
          format={"DD/MM/YYYY"}
          value={dayjs(filterValues[filter.field]?.value)}
          onChange={(newValue: any) => handleChange(filter.field, newValue)}
          // renderInput={(params: any) => <TextField {...params} />}
          sx={{
            marginBottom: "0px !important",
            label: {
              color: "rgba(0, 0, 0, 0.6) !important",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#0000003b !important",
              },
              "& input": {
                color: "rgba(0, 0, 0, 0.6) !important",
              },
            },
          }}
        />
      );
    }

    if (filter.type === EDynamicColumnType.SELECT) {
      setElement(
        <FormControl fullWidth>
          <InputLabel id={`${filter.field}-label`}>
            {filter.label}
          </InputLabel>
          <Select
            labelId={`${filter.field}-label`}
            id={filter.field}
            value={filterValues[filter.field]?.value || ""}
            className={styles.field}
            label={filter.label}
            onChange={(e) =>{
              const newValue = e.target.value;

              // Notifica al componente padre si es necesario
              if (onOtherComponentChange && filter.field === "companyId") {
                onOtherComponentChange(newValue);
              }

              // Actualiza el estado local para reflejar el cambio
              handleChange(filter.field, newValue);
            }
            }
            sx={{ marginBottom: "0px !important" }}

          >
            {filter.values?.map((option: ISelectOption) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }
  }, [filter, filterValues, handleChange, setElement,onOtherComponentChange]);


  return (
    <Grid item md={filter.grid}>
      {element}
    </Grid>
  );
}